import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useShopDataQuery } from "@/query/shopDataQuery"
import { setNewServicePrestatereId } from "@/store/cashRegisterReducers/cashRegisterSlice"
import { useAppDispatch, useAppSelector } from "@/store/store"
import { getPrestateres } from "@/utils/functions/getPrestateres"
import { useMemo } from "react"

export const PrestatereSection: React.FC = () => {
  const dispatch = useAppDispatch()
  const { collectionInfo } = useAppSelector((state) => state.cashRegister)
  const { shopData } = useShopDataQuery()

  const prestateres = useMemo(() => {
    if (!shopData) return []
    return getPrestateres(shopData)
  }, [shopData])

  const handlePrestatereChange = (value: string) => {
    dispatch(setNewServicePrestatereId(value))
  }

  return (
    <div className="space-y-4 border-1 border-border bg-card rounded-lg p-4 flex justify-between items-center">
      <h3 className="text-lg font-semibold text-card-foreground m-0">
        Prestataire
      </h3>
      <div className="flex gap-4">
        <div className="space-y-2">
          <Select
            value={collectionInfo?.newServicePrestatereId || ""}
            onValueChange={handlePrestatereChange}
          >
            <SelectTrigger id="prestatere-select" className="w-full">
              <SelectValue placeholder="Sélectionner un prestataire" />
            </SelectTrigger>
            <SelectContent>
              {prestateres.map((prestatere) => (
                <SelectItem key={prestatere.id} value={prestatere.id}>
                  {`${prestatere.givenName} ${prestatere.familyName}`}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  )
}
